var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"link"}},[_c('a',{attrs:{"href":_vm.href,"target":"_blank"}},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }